<template>
  <data-list
    ref="dataList"
    class="content"
    url="/activity/delivery-service"
    entity-name="预约"
    :add-btn="false"
    hide-edit
    @detail="handleDetail"
    :search-key-type="searchKeyType"
    :hide-action="!editable"
    :modal-width="600"
    :modal-form="modalForm"
    :query="query"
    :action="action"
    :columns="columns">
    <template v-slot:button="{form}">
      <a-button type="primary" :loading="exporting" @click="exportData(form)">{{exporting ? '正在导出' : '数据导出'}}</a-button>
    </template>
    <template v-slot:action="{item}">
      <a class="txt-btn" :class="{disabled: item.status != 2}" @click="sendEmail(item)">发送邮件</a>
    </template>
    <template v-slot:query="{form}">
      <a-form-model-item label="提交日期">
        <a-range-picker
          v-model="form.time"
          :placeholder="['开始时间', '结束时间']"
          format="YYYY-MM-DD"
          value-format="YYYY-MM-DD"
          @change="updateList" />
      </a-form-model-item>
      <a-form-model-item label="派车状态">
        <a-select v-model="form.status" allowClear :options="statusOptions" placeholder="请选择" @change="updateList" style="width: 200px"></a-select>
      </a-form-model-item>
      <a-form-model-item label="邮件发送状态" v-if="false">
        <a-select v-model="form.email_status" allowClear :options="emailStatusOptions" placeholder="请选择" @change="updateList" style="width: 200px"></a-select>
      </a-form-model-item>
    </template>
  </data-list>
</template>

<script>
    import mixins from "../mixins";
    import {downLoadBlobFile} from "../../../common/js/tool";

    export default {
        name: "DeliveryList",
        data() {
            return {
                dateList: [],
                timeList: [],
                statusOptions: [
                    { value: 2, label: '已派车' },
                    { value: 1, label: '未派车' },
                ],
                emailStatusOptions: [
                    { value: 2, label: '已发送' },
                    { value: 1, label: '未发送' },
                ],
                columns: [
                    {title: '提交时间', dataIndex: 'create_time'},
                    {
                        title: '车辆及数量',
                        dataIndex: 'deliveryInfo',
                        width: 200,
                        customRender: text => {
                            return text ?
                                <a-space direction="vertical">
                                    { text.map(c => <a-tag>{c.activityDeliverySet?.chinese_name}*{c.num}</a-tag>) }
                                </a-space> : '无'
                        }
                    },
                    {title: '接站地点', dataIndex: 'location'},
                    {title: '航班/车次', dataIndex: 'train_flight'},
                    {title: '接站时间', dataIndex: 'arrival_time'},
                    {title: '送站地点', dataIndex: 'leave_location'},
                    {title: '姓名', dataIndex: 'user_name'},
                    {title: '联系方式', dataIndex: 'mobile'},
                    {title: '邮箱', dataIndex: 'email'},
                    {title: '派车状态', dataIndex: 'status', customRender: text => text == 2 ? '已派车' : '未派车'},
                    {title: '邮件发送状态', dataIndex: 'email_status', customRender: text => text == 2 ? '已发送' : '未发送'},
                ],
                modalForm: {
                    labelAlign: 'left',
                    labelCol: {span: 6},
                    wrapperCol: {span: 18}
                },
                moduleKey: 'food-order',
                exporting: false,
                searchKeyType: {
                    time: (val) => val && val.length == 2 ? `&filter[create_time][gte]=${val[0]} 00:00:00&&filter[create_time][lte]=${val[1]} 23:59:59` : ""
                }
            }
        },
        mixins: [mixins],
        computed: {
            action() {
                return this.editable ? ['add', 'delete', 'update', 'query', 'audit'] : ['query'];
            },
            activity() {
                return this.$store.getters.activity;
            },
            query() {
                let res = '&expand=deliveryInfo.activityDeliverySet';
                const activity = this.activity;
                if(activity) {
                    res += `&filter[activity_id]=${activity.id}`
                }
                return res;
            }
        },
        methods: {
            sendEmail(item) {
                if (item.status == 2) {
                    this.$confirm({
                        title: "提示",
                        content: "确定发送邮件吗？",
                        onOk: () => {
                            this.$axios(`/activity/delivery-service/send-email?service_id=${item.id}`).then(res => {
                                if(res.error == 0) {
                                    this.$message.success("已发送");
                                    this.$set(item, 'email_status', 2);
                                } else {
                                    this.$message.error(res.msg || "发送失败");
                                }
                            })
                        }
                    })
                }
            },
            updateList() {
                this.$refs.dataList.getList();
            },
            exportData(form) {
                if(this.exporting) return;
                this.exporting = true;
                let fileName = '预约送机数据';
                let url = "/activity/delivery-service/export";
                const params = {};
                if (form.time && form.time.length == 2) {
                    const [start, end] = form.time;
                    params.start_time = `${start} 00:00:00`;
                    params.end_time = `${end} 23:59:59`;
                }
                if (form.status) {
                    params.status = form.status;
                }
                if (form.email_status) {
                    params.email_status = form.email_status;
                }
                this.$axios({
                    url,
                    params,
                    noTempleFilter: true,
                    responseType: 'blob',
                }).then(res => {
                    downLoadBlobFile(res, fileName);
                }).finally(() => {
                    this.exporting = false;
                });
            },
            handleDetail({item}) {
                this.$router.push({name: 'ActivityDeliveryDetail', params: {carId: item.id}})
            },
        }
    }
</script>

<style scoped lang="less">
</style>
